export default "__VITE_ASSET__D0lD466T__"